import { useEffect } from 'react';

export const useSessionTimer = (
  isRunning,
  startTime,
  sessionDuration,
  setGlobalState,
) => {
  useEffect(() => {
    let timer;
    if (isRunning) {
      timer = setInterval(() => {
        const now = new Date().getTime();
        const currentSessionDuration = Math.floor((now - startTime) / 1000);
        setGlobalState((prevState) => ({
          ...prevState,
          duration: prevState.sessionDuration + currentSessionDuration,
        }));
      }, 1000);
    } else {
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [isRunning, startTime, sessionDuration, setGlobalState]);
};
